import Home from '../modules/home';
import React from 'react';

const HomePage = () => {
  return <Home />;
};

export default HomePage;
